exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2UUuB-5KhA0VYiWnxTtwqh{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._2UUuB-5KhA0VYiWnxTtwqh{margin-left:8px}html[dir=rtl] ._2UUuB-5KhA0VYiWnxTtwqh{margin-right:8px}html[dir] ._1xZzpmRfeiuiCdCZXgX6E9:hover{background:transparent}", ""]);
// Exports
exports.locals = {
	"moreLabel": "_2UUuB-5KhA0VYiWnxTtwqh",
	"moreRoot": "_1xZzpmRfeiuiCdCZXgX6E9"
};